const o = {
  Home: "HOME",
  Mobile: "MOBILE",
  Business: "BUSINESS"
};
export {
  o
};
//# sourceMappingURL=AlternatePhoneType-940ae4fc.mjs.map
